// extracted by mini-css-extract-plugin
export default {"failReason":"ElectricityBillErrorModal_failReason__9Ln7F"};